export const ACTIVITY_FAVORITE = 1;
export const ACTIVITY_FOLLOW = 2;
export const ACTIVITY_RATING = 3;
export const FOLLOW_TYPES = ['MODEL', 'PHOTOGRAPHER'];
